/* Judge.me owns review data, sorting, pagination, forms and star rendering. */
(() => {
  'use strict';
  const instances = new Map();
  const toCount = value => {
    if (value === null || value === undefined || String(value).trim() === '') return null;
    const count = Number(value);
    return Number.isInteger(count) && count >= 0 ? count : null;
  };
  function attach(host) {
    if (instances.has(host)) return;
    const sync = () => {
      const widget = host.matches('.jdgm-review-widget') ? host : host.querySelector('.jdgm-review-widget');
      if (!widget) return;
      const id = widget.dataset.productId || widget.dataset.id;
      // Use the product TOTAL, never the currently filtered/paginated list.
      const data = window.jdgm?.data?.reviewWidget?.[id];
      let total = toCount(data?.number_of_reviews);
      if (total === null) {
        const legacy = widget.querySelector('.jdgm-rev-widg[data-number-of-reviews]');
        total = toCount(legacy?.getAttribute('data-number-of-reviews'));
      }
      // Native app setting is also saved in product.json. This supports newly
      // added blocks and lets Judge.me apply its own empty-state logic.
      if (widget.dataset.emptyState !== 'hide_widget') widget.dataset.emptyState = 'hide_widget';
      const preview = widget.dataset.previewMode;
      // Theme-editor sample/empty previews remain owned by the app.
      if (window.Shopify?.designMode && preview === 'sample_data') { host.hidden = false; host.removeAttribute('data-gmox-reviews-empty'); return; }
      if (window.Shopify?.designMode && preview === 'no_reviews') { host.hidden = true; host.setAttribute('data-gmox-reviews-empty', ''); return; }
      if (total !== null) {
        host.hidden = total === 0;
        host.toggleAttribute('data-gmox-reviews-empty', total === 0);
      }
      // Unknown/loading is not zero: leave Judge.me to finish loading.
    };
    const observer = new MutationObserver(sync);
    observer.observe(host, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['data-number-of-reviews', 'data-product-id', 'data-id', 'data-empty-state'] });
    instances.set(host, observer);
    sync();
  }
  function init(root = document) {
    if (root.matches?.('[data-gmox-reviews]')) attach(root);
    root.querySelectorAll('[data-gmox-reviews]').forEach(attach);
    // Also support app blocks inside another section, without our wrapper.
    if (root.matches?.('.jdgm-review-widget')) attach(root.closest('[data-gmox-reviews]') || root);
    root.querySelectorAll('.jdgm-review-widget').forEach(widget => attach(widget.closest('[data-gmox-reviews]') || widget));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  window.addEventListener('load', () => init(), { once: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((observer, host) => {
      if (event.target.contains(host)) { observer.disconnect(); instances.delete(host); }
    });
  });
})();
